import { render, staticRenderFns } from "./VenueNearby.vue?vue&type=template&id=dff089fe"
import script from "./VenueNearby.vue?vue&type=script&lang=ts"
export * from "./VenueNearby.vue?vue&type=script&lang=ts"
import style0 from "./VenueNearby.vue?vue&type=style&index=0&id=dff089fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports